import { Box, Grid, TextField } from '@mui/material';
import { useState, useEffect } from 'react';
import { IRupturaHipotetica } from '../../../services/api/action-plan/Pae';

interface RuptureProps {
    smDown: boolean;
    value: IRupturaHipotetica | undefined,
    onChange: (data: IRupturaHipotetica) => void
}

export const Rupture = ({onChange, smDown, value}: RuptureProps) => {

    const [data, setData] = useState<IRupturaHipotetica>({
        caracterizacao_reologica: '',
        cenarios_simulados: '',
        definicao_zas: '',
        falha_cenario_critico: '',
        fluxo_newtoniano: '',
        parada_mancha: '',
        reologia: '',
        tr_critico: '',
        tr_jusante: '',
        volume_mobilizado: '',
        volume_mobilizado_m3: ''
    });

    useEffect(() => {
        if (value) {
            setData(value);
        }
    }, [value]);

    const handleChange = (e: React.ChangeEvent<HTMLInputElement | HTMLTextAreaElement>) => {
        const { name, value } = e.target;
        const newData = {
            ...data,
            [name]: value,
        };
        setData(newData);
        onChange(newData);
    };

    return(
        <Box flex={1}>
            <Grid container spacing={1}>
                <Grid item xs={smDown ? 12 : 6}>
                    <TextField
                        label='Fluxo Newtoniano'
                        type='text'
                        name='fluxo_newtoniano'
                        fullWidth
                        InputLabelProps={{ shrink: true }}
                        onChange={(e) => handleChange(e)}
                        value={data?.fluxo_newtoniano}
                    />
                </Grid>
                <Grid item xs={smDown ? 12 : 6}>
                    <TextField
                        InputLabelProps={{ shrink: true }}
                        label='Reologia'
                        type='text'
                        name='reologia'
                        fullWidth
                        onChange={(e) => handleChange(e)}
                        value={data?.reologia}
                    />
                </Grid>
                <Grid item xs={smDown ? 12 : 6}>
                    <TextField
                        InputLabelProps={{ shrink: true }}
                        label='Caracterização reológica'
                        type='text'
                        name='caracterizacao_reologica'
                        fullWidth
                        onChange={(e) => handleChange(e)}
                        value={data?.caracterizacao_reologica}
                    />
                </Grid>
                <Grid item xs={smDown ? 12 : 6}>
                    <TextField
                        InputLabelProps={{ shrink: true }}
                        label='Cenários simulados'
                        type='text'
                        name='cenarios_simulados'
                        fullWidth
                        onChange={(e) => handleChange(e)}
                        value={data?.cenarios_simulados}
                    />
                </Grid>
                <Grid item xs={smDown ? 12 : 6}>
                    <TextField
                        InputLabelProps={{ shrink: true }}
                        label='Modo de falha do cenário mais crítico'
                        type='text'
                        name='falha_cenario_critico'
                        fullWidth
                        onChange={(e) => handleChange(e)}
                        value={data?.falha_cenario_critico}
                    />
                </Grid>
                <Grid item xs={smDown ? 12 : 6}>
                    <TextField
                        InputLabelProps={{ shrink: true }}
                        label='Volume mobilizado (m³)'
                        type='text'
                        name='volume_mobilizado_m3'
                        fullWidth
                        onChange={(e) => handleChange(e)}
                        value={data?.volume_mobilizado_m3}
                    />
                </Grid>
                <Grid item xs={smDown ? 12 : 6}>
                    <TextField
                        InputLabelProps={{ shrink: true }}
                        label='Volume mobilizado (%)'
                        type='text'
                        name='volume_mobilizado'
                        fullWidth
                        onChange={(e) => handleChange(e)}
                        value={data?.volume_mobilizado}
                    />
                </Grid>
                <Grid item xs={smDown ? 12 : 6}>
                    <TextField
                        InputLabelProps={{ shrink: true }}
                        label='TR considerado no vale de jusante'
                        type='text'
                        name='tr_jusante'
                        fullWidth
                        onChange={(e) => handleChange(e)}
                        value={data?.tr_jusante}
                    />
                </Grid>
                <Grid item xs={smDown ? 12 : 6}>
                    <TextField
                        InputLabelProps={{ shrink: true }}
                        label='TR considerado no cenário mais crítico'
                        type='text'
                        name='tr_critico'
                        fullWidth
                        onChange={(e) => handleChange(e)}
                        value={data?.tr_critico}
                    />
                </Grid>
                {/* Verificar qual o campo correto correspondente */}
                {/* <Grid item xs={smDown ? 12 : 6}>
                    <TextField
                        InputLabelProps={{ shrink: true }}
                        label='Critério de parada da mancha'
                        type='text'
                        name='cenarios_simulados'
                        fullWidth
                        onChange={(e) => handleChange(e)}
                        value={data?.cr}
                    />
                </Grid> */}
                <Grid item xs={smDown ? 12 : 6}>
                    <TextField
                        InputLabelProps={{ shrink: true }}
                        label='Critério de definição da ZAS'
                        type='text'
                        name='definicao_zas'
                        fullWidth
                        onChange={(e) => handleChange(e)}
                        value={data?.definicao_zas}
                    />
                </Grid>
            </Grid>
        </Box>
    );

};